import React from 'react';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { Box } from '@mui/material';
import { LinkButton } from 'src/components/LinkButton/LinkButton.styles';
const FormAppendage = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Box, {
    textAlign: "right"
  }, /*#__PURE__*/React.createElement(Link, {
    href: '/forgot-password',
    passHref: true
  }, /*#__PURE__*/React.createElement(LinkButton, null, t('b2c.login_form.forgotPasswordLink'))));
};
export default FormAppendage;